<script setup>
import { ref,onMounted,watch } from 'vue'
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import {readJSON} from '@/utils/fetch.js'; 
import {setCssColors} from '@/utils/setcsscolors.js';
import {createGoogleMapsLink,loadImageAsync} from '@/utils/helpers.js'; 
import SideBar from '@/components/SideBar.vue';
import QrCamera from '@/components/QrCamera.vue';
import Header from '@/components/Header.vue';
import { useI18n } from "vue-i18n";
//import { read } from 'fs';

const windowWidth = window.innerWidth; 
const map = ref(null);
let loadFirst = [];
const showNavBar = ref(false);
const mapLoaded = ref(false);
let expressionMarkerPart = [];
const currentCoordinate = ref(0);
const { t, setLocaleMessage,locale  } = useI18n({ useScope: 'global' })

onMounted(() => {
  let parameter = window.location.search.substring(1);
  const VITE_DATA_URL = import.meta.env.VITE_DATA_URL;
  const VITE_MIZA_URL = import.meta.env.VITE_MIZA_URL;
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  

  mapboxgl.accessToken = 'pk.eyJ1IjoiYXI5aXQiLCJhIjoiY2tzMDIzdDZoMWZ2bDJxczduMDJrcXVnYyJ9.cRFgHrdHVNT2-euD0Lgn0Q';
  useItineraryStore().map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    zoom: 12
  });
  getLocation();
  setCssColors();
  useItineraryStore().setItinerary();  
});

function getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.watchPosition(showPosition);
  } else {
    console.log("Geolocation is not supported by this browser.");
  }
}
function showPosition(position) {
  currentCoordinate.value = [position.coords.longitude,position.coords.latitude];
}


function checkIfNewLocation() {

}

async function setData() {
  //debugger;
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  loadFirst = [];
  let allKeys = Object.keys(useItineraryStore().itinerary);
  if(allKeys.length == 0) {
    useItineraryStore().map.setCenter(['14.5058', '46.0569']);
    useItineraryStore().map.setZoom(12);
    //useItineraryStore().setCategories();
    return;

  }
  useItineraryStore().allKeys = allKeys;
  let selectedPath = allKeys[useItineraryStore().selectedPathNumber];
  useItineraryStore().allPathsNumber = allKeys.length;
  useItineraryStore().selectedPath = selectedPath;

  if(useItineraryStore().itinerary[selectedPath].options.destination == useItineraryStore().currentDestination) {
    setMap();
    useItineraryStore().itinerary[selectedPath].pois.forEach((poi) => {
      let category = poi.properties.categories[0] + '-' + poi.properties.categories[1];
      loadFirst.push(category);
    });
  }else {
    useItineraryStore().currentDestination = useItineraryStore().itinerary[selectedPath].options.destination;

    // Load the initial options.json
    const optionsResult = await readJSONAsync(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination + '/options.json');
    useItineraryStore().options = JSON.parse(optionsResult);


    readJSON(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination +'/selectors.json',function (result){
      let jsonObject = JSON.parse(result);
      useItineraryStore().selectors = jsonObject;
      if(useItineraryStore().markersImages.size == 0) {
        useItineraryStore().setCategories();
      }
      
    });

    useItineraryStore().itinerary[selectedPath].pois.forEach((poi) => {
      let category = poi.properties.categories[0] + '-' + poi.properties.categories[1];
      loadFirst.push(category);
    });
    
    setMap();
    setLocalization();
  }
}


async function setLocalization() {
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  const defaultLanguage = useItineraryStore().options.languages[0] // or a specific logic to determine the default language
  useItineraryStore().selectedLanguage = defaultLanguage;
  useItineraryStore().allLanguages = useItineraryStore().options.languages;
  locale.value = defaultLanguage // Update the default language

  // Create an array of promises for loading each language file
  const languagePromises = useItineraryStore().options.languages.map(language =>
  Promise.all([
    readJSONAsync(VITE_DESTINATION_DATA_URL + 'common/i18n/' + language + '.json'),
    readJSONAsync(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination + '/locale_poi-' + language + '.json')
  ])
);

  // Wait for all language files to be loaded
  const languagesData = await Promise.all(languagePromises);

  // Optionally, process the results (e.g., setting locale messages)
  languagesData.forEach(([i18nData, poiData], index) => {
    const language = useItineraryStore().options.languages[index];
    const i18nJson = JSON.parse(i18nData);
    const poiJson = JSON.parse(poiData);
    const combinedData = { ...i18nJson, ...poiJson };
    setLocaleMessage(language, combinedData);
  });
}


function setMap() {
  //debugger;

  let lng = useItineraryStore().itinerary[useItineraryStore().selectedPath].pois[1].geometry.coordinates[0];
  let lat = useItineraryStore().itinerary[useItineraryStore().selectedPath].pois[1].geometry.coordinates[1];

  useItineraryStore().map.setCenter([lng, lat]);
  useItineraryStore().map.setZoom(12);
}

const loadMapMarkersAndLayers = async () => {
  try {
    addMarkerLayer();
    loadMarkersToMap(loadFirst).then(() => {
      showPath();
    });
  } catch (error) {
    console.error('Error loading map markers', error);
  }
};

async function loadMarkersToMap(markers) {
  for(let i = 0; i < markers.length; i++) {
      if(!useItineraryStore().map.hasImage('image-marker-' + loadFirst[i])) {
        let imageMarker = useItineraryStore().markersImages.get(loadFirst[i]);
        if(imageMarker == undefined) {
          imageMarker = useItineraryStore().markersImages.get('empty-marker');
        }
      
        let image = await loadImageAsync(useItineraryStore().map, imageMarker);
        useItineraryStore().map.addImage('image-marker-' + loadFirst[i], image);
      }
    }
}

const addMarkerLayer = () => {
  if (useItineraryStore().expressionMarkerPart.length > 1) {
    useItineraryStore().expressionMarkerPart.push('default-marker');
  } else {
    useItineraryStore().expressionMarkerPart = 'default-marker'
  }

  let layout = {}; 
  if(useItineraryStore().expressionMarkerPart == 'default-marker') {
    layout = {
        'icon-size': returnMarkerScale(0.1,0.8),
        'text-offset': [0, 1],
        'text-anchor': 'bottom',
        'icon-anchor': 'bottom',
        "icon-allow-overlap": true,  // Allow icons to overlap with each other
        "icon-ignore-placement": true  // Ignore the placement of other icons when placing a particular icon
    }
  }else {
    layout = {
        'icon-image': [
          'case',
          ...useItineraryStore().expressionMarkerPart
        ],
        'icon-size': returnMarkerScale(0.1,0.8),
        'text-offset': [0, 1],
        'text-anchor': 'bottom',
        'icon-anchor': 'bottom',
        "icon-allow-overlap": true,  // Allow icons to overlap with each other
        "icon-ignore-placement": true  // Ignore the placement of other icons when placing a particular icon
    }
  }
  console.log("marker layour added AND EXPRESSION");
    useItineraryStore().map.addLayer({
        id: 'markers',
        type: 'symbol',
        source: 'clustering',
        filter: ['!', ['has', 'point_count']], // Filter for individual markers (not clusters)
        layout: layout,
        paint: {
          'icon-opacity': ['get', 'opacity']
        }
      });

};

function showPath() {
    let pathColor = "#4CC8CD";
    console.log('show path');
    let id = 'path_' + useItineraryStore().selectedPath;
    let coordinates = "";
    let selectedPathData = useItineraryStore().itinerary[useItineraryStore().selectedPath];

    coordinates = selectedPathData.route.geometry;
    let path = useItineraryStore().map.addLayer({
        id: id,
        type: 'line',
        source: {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: coordinates,
            }
        },
        layout: {
            'line-join': 'round',
            'line-cap': 'round'
        },
        paint: {
            'line-width': 3,
            'line-color': pathColor
        }
    });
    //return id;
    useItineraryStore().blockNavigation = false;
}

function returnMarkerScale(scale05,scale15) {
  let scale0_5 = scale05;
  let scale1_5 = scale15;

  if(windowWidth <= 1920) {
    scale0_5 = scale0_5 / 2;
    scale1_5  = scale1_5 / 2;
  }
  return [
    'interpolate',
    ['linear'],
    ['zoom'],
    0, scale0_5,
    22, scale1_5
  ]
}

const setupClusterSource = () => {
  let itinerary = useItineraryStore().itinerary;
  let firstKey = Object.keys(itinerary)[useItineraryStore().selectedPathNumber];
  let firstProperty = itinerary[firstKey];
  let selectedPathData = useItineraryStore().itinerary[useItineraryStore().selectedPath];
  if(firstKey == undefined) {
   return;
  }

  let startingPoint = {
    type: 'Feature',
    geometry: {type: 'Point',coordinates: selectedPathData.route.geometry.coordinates[0]},          
    properties: {categories: ['current','location']}
  };

  let poisCopy = [...firstProperty.pois];
  poisCopy.unshift(startingPoint);
 
  let clusters = {
    type: "FeatureCollection",
    features:  poisCopy
  }
  if (useItineraryStore().map.getSource('clustering')) {
    useItineraryStore().map.getSource('clustering').setData(clusters);
    loadMarkersToMap(loadFirst);
    showPath();
  }else {
    useItineraryStore().map.addSource('clustering', {
        'type': 'geojson',
        'data': clusters,
        'cluster': false,
        //clusterMaxZoom: 16,
        clusterRadius: 80,
        clusterProperties: {
            'hasOpaqueMarker': ['any', ['get', 'hasOpaqueMarker']]
        }
    });
    loadMapMarkersAndLayers();
  }
  
  useItineraryStore().googlemapsDirectionsLink = createGoogleMapsLink(selectedPathData,currentCoordinate.value);
};


function readJSONAsync(url) {
  return new Promise((resolve, reject) => {
    readJSON(url, result => {
      resolve(result);
    });
    // Consider adding error handling here
  });
}


watch(
    () => useItineraryStore().itinerary,
    (newValue,oldValue) => {
      let allKeys = Object.keys(oldValue);

      // if the itinerary is empty means its on load
      if(allKeys.length == 0) {
        if(useItineraryStore().map == null) {
          console.log("is null")
          return;
        }
        
        if (mapLoaded.value == true) {
        //if app was first loaded without any data
          console.log("first qr code");
          setData().then(() => {
            
          });
        }else {
          useItineraryStore().map.on('load', () => {


            mapLoaded.value = true;
            setData();
          });
        } 
      }else {
        //when new data is loaded from qr code
        console.log("new itinerary");
        if (useItineraryStore().map.getLayer('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber])) {
          console.log("remove Layer");
          useItineraryStore().map.removeLayer('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber]);
          useItineraryStore().map.removeSource('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber]);
          setData().then(() => {
            setupClusterSource();
            setMap();
          });
        }

      }
    }
  )

  watch(
    () => useItineraryStore().categoriesMarkersDone,
    (newValue) => {
      if(newValue) {
        console.log("useItineraryStore().categoriesMarkersDone", useItineraryStore().categoriesMarkersDone );
        const currentImage = useItineraryStore().markersImages.get('current-location');
        console.log("currentImage",currentImage);
            useItineraryStore().map.loadImage(currentImage, function(error, image) {
              if (error) throw error;
              useItineraryStore().map.addImage('image-marker-current-location', image);
            });
        setupClusterSource();
      }
    }
  )

  watch(
    () => useItineraryStore().selectedPathNumber,
    (newValue,oldValue) => {
      //debugger;
      console.log("selectedPathNumber");
      useItineraryStore().blockNavigation = true;
      if (useItineraryStore().map.getLayer('path_' + useItineraryStore().allKeys[oldValue])) {
        console.log("remove Layer");
        useItineraryStore().map.removeLayer('path_' + useItineraryStore().allKeys[oldValue]);
        useItineraryStore().map.removeSource('path_' + useItineraryStore().allKeys[oldValue]);
        setData().then(() => {
          setupClusterSource();
        });
      }else {
        setMap();
        setupClusterSource();
      }
    }
  )
</script>

<template>
  <!--When more screens install router and make a new component-->
  <div>
    <Header></Header>
    <SideBar></SideBar>
    <QrCamera v-if="useItineraryStore().showCamera"></QrCamera>
    <div id="map" style="width: 100vw; height: 100vh; right:0; top:0;"></div>
  </div>
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
